import AbstractNomenclature, { DataColumn } from "./common/AbstractNomenclature";
import { FormikProvider } from "formik";
import CustomInputText from "../../components/forms/CustomInputText";
import * as Yup from "yup";
import { subjectsApi } from "../../services/nomenclatures/subjectsApi";
import { SubjectResponse } from "../../models/dtos";
import CustomDropdown from "../../components/forms/CustomDropdown";
import { specialitiesApi } from "../../services/nomenclatures/specialitiesApi";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

interface SubjectChildrenEditorProps {
  value: Array<{ name: string; nameEn: string | null }>;
  onChange: (newValue: Array<{ name: string; nameEn: string | null }>) => void;
}

const SubjectChildrenEditor = ({ value, onChange }: SubjectChildrenEditorProps) => {
  return (
    <div className="mt-4">
      <h3>Под-изпити (при мултикомпонентно оценяване)</h3>
      <DataTable value={value || []}>
        <Column
          field="name"
          header="Име"
          body={(rowData, { rowIndex }) => (
            <InputText
              value={rowData.name}
              onChange={(e) => {
                const newChildren = [...(value || [])];
                newChildren[rowIndex] = { ...rowData, name: e.target.value };
                onChange(newChildren);
              }}
            />
          )}
        />
        <Column
          field="nameEn"
          header="Име на английски"
          body={(rowData, { rowIndex }) => (
            <InputText
              value={rowData.nameEn}
              onChange={(e) => {
                const newChildren = [...(value || [])];
                newChildren[rowIndex] = { ...rowData, nameEn: e.target.value };
                onChange(newChildren);
              }}
            />
          )}
        />
        <Column
          body={(rowData) =>
            rowData.name === "" && rowData.nameEn === "" ? (
              <Button
                icon="pi pi-trash"
                className="p-button-danger"
                onClick={() => {
                  const newChildren = value.filter((child) => child !== rowData);
                  onChange(newChildren);
                }}
              />
            ) : null
          }
        />
      </DataTable>
      <Button
        label="Добави под-изпит"
        className="mt-2"
        onClick={() => {
          const newChildren = [...(value || [])];
          newChildren.push({ name: "", nameEn: "" });
          onChange(newChildren);
        }}
      />
    </div>
  );
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Името е задължително"),
  children: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Името е задължително"),
    }),
  ),
});

export const editDialog = (specialities: any) => ({
  renderForm: (formik: any) => (
    <FormikProvider value={formik}>
      {formik.values.subjectId && <CustomInputText label="ID" id="subjectId" disabled />}
      <CustomInputText label="Име" id="name" />
      <CustomInputText label="Име на английски" id="nameEn" />
      <CustomInputText label="Минимално преминати под-изпити (при мултикомпонентно оценяване)" id="minPassedExams" />
      <CustomDropdown
        label="Само за специалност (при мултикомпонентно оценяване)"
        id="specialityId"
        options={specialities || []}
        optionLabel="name"
        optionValue="specialityId"
      />

      <SubjectChildrenEditor
        value={formik.values.children || []}
        onChange={(newChildren) => formik.setFieldValue("children", newChildren)}
      />
    </FormikProvider>
  ),
  validationSchema,
});

const Subjects = () => {
  const { data: specialities } = specialitiesApi.useGetSpecialitiesQuery();

  const api = {
    useGetListQuery: subjectsApi.useGetSubjectsQuery,
    useUpdateItemMutation: subjectsApi.useUpdateSubjectMutation,
    useDeleteItemMutation: subjectsApi.useDeleteSubjectMutation,
  };

  const columns: DataColumn<SubjectResponse>[] = [
    { field: "subjectId", header: "ID", sortable: true, filter: true },
    { field: "name", header: "Име", sortable: true, filter: true },
    { field: "nameEn", header: "Име на английски", sortable: true, filter: true },
    { field: "minPassedExams", header: "Минимално преминати под-изпити", sortable: true, filter: true },
    { field: "specialityName", header: "Само за специалност", sortable: true, filter: true },
    { field: "parentName", header: "Родител", sortable: true, filter: true },
  ];

  return (
    <AbstractNomenclature
      api={api}
      columns={columns}
      editDialog={editDialog(specialities?.data)}
      exportFilename="subjects"
      title="Дисциплини"
      idField="subjectId"
    />
  );
};

export default Subjects;
